export default __webpack_public_path__ + "static/media/bar.a665e416.jpg";